<div class="login_wrap">
  <form name="login" (ngSubmit)="getLoginInfo()">
    <div class="text-center">
      <img alt="DPIS" src="/Images/FullColor_HorizontalArcxis.png" class="dpis-image" />
    </div>
    <div class="form-horizontal login-details-wrap" role="form">
      <div class="text-center">
        <div class="row">
          <div class="col-md-4"></div>
          <div class="col-md-4">
            <div>
              <label>Email Address / Username:</label>
              <input
                [(ngModel)]="emailAddress"
                class="form-control login"
                name="username"
                required
              />
            </div>
            <div>
              <label>Password:</label>
              <input
                [(ngModel)]="password"
                class="form-control login"
                type="password"
                name="password"
              />
            </div>
            <div>
              @if (!validLogin) {
                <div class="flipInX animated error-display">*Invalid Login Information</div>
              }
            </div>
            <div>
              @if (!verifiedEmail) {
                <div class="flipInX animated error-display">
                  *Email Address needs to be verified. Please verify log in credentials by clicking
                  on the link in the email sent to your email address on file.
                </div>
              }
            </div>
          </div>
          <div class="col-md-4"></div>
        </div>
      </div>
    </div>
    <div class="form-group row login-btn-wrap">
      <div class="col-md-4"></div>
      <div class="col-md-4">
        <button type="submit" class="form-control full dpis-background login">Login</button>
        <button type="button" class="form-control full dpis-background login" (click)="resetPassword()">
          Forgot Password
        </button>
        @if (appVersion.version()) {
          <div class="app-version">v{{ appVersion.version() }}</div>
        }
      </div>
      <div class="col-md-4"></div>
    </div>
  </form>
</div>
